import { Gefahr, Produkt, Produktlinie, ZusatzoptionItem } from '@ps20-frontend/frontend-models';

export function getSelectedProduktlinie(produkt: Produkt): Produktlinie {
  return produkt?.produktlinien?.find(tarifItem => tarifItem.selected) || null;
}

export function getJahresNettoOfSelectedGefahren(selectedProduktlinie: Produktlinie): number {
  return selectedProduktlinie.gefahren
    .filter((gefahr: Gefahr) => gefahr.isSelected)
    .map((gefahr: Gefahr) => gefahr.nettopreisProJahr)
    .reduce((a, b) => a + b, 0);
}

export function getJahresNettoOfSelectedBausteine(zusatzoptionen: ZusatzoptionItem[]): number {
  return zusatzoptionen
    .filter((zusatzoption: ZusatzoptionItem) => zusatzoption.isSelected || zusatzoption.isInclusive)
    .map((zusatzoption: ZusatzoptionItem) => zusatzoption.nettopreisProJahr)
    .reduce((a, b) => a + b, 0);
}

export function getJahresNettoOfInklusivBausteine(zusatzoptionen: ZusatzoptionItem[]): number {
  return zusatzoptionen
    .filter((zusatzoption: ZusatzoptionItem) => zusatzoption.isInclusive)
    .map((zusatzoption: ZusatzoptionItem) => zusatzoption.nettopreisProJahr)
    .reduce((a, b) => a + b, 0);
}

export function getBruttoOfInklusivBausteine(zusatzoptionen: ZusatzoptionItem[]): number {
  return zusatzoptionen
    .filter((zusatzoption: ZusatzoptionItem) => zusatzoption.isInclusive)
    .map((zusatzoption: ZusatzoptionItem) => zusatzoption.bruttopreis)
    .reduce((a, b) => a + b, 0);
}
